import React, { lazy, useEffect } from "react";
import "./HomePage.scss";
import "./ResHomePage.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import UserReview from "../../Components/UserReview/UserReview";
import $ from "jquery";
import MetaDecorator from "../../Components/MetaDecorator/MetaDecorator";
//Component
const HeaderV2 = lazy(() => import("../../Components/HeaderV2/HeaderV2"));
const UseCases = lazy(() => import("../../Components/UseCases/UseCases"));
const UnifiedPlatform = lazy(() =>
  import("../../Components/Home/UnifiedPlatform/UnifiedPlatform")
);
const Questions = lazy(() => import("../../Components/Questions/Questions"));
const MasterContactsConnect = lazy(() =>
  import("../../Components/MasterContacts/MasterContactsConnect")
);
const DesignedBuilt = lazy(() =>
  import("../../Components/Home/DesignedBuilt/DesignedBuilt")
);
const ResFooter = lazy(() =>
  import("../../Components/Home/CADFooter/ResFooter")
);
const PersonalBrand = lazy(() =>
  import("../../Components/Home/PersonalBrand/PersonalBrand")
);
const Commitments = lazy(() =>
  import("../../Components/Home/Commitments/Commitments")
);
const Networking = lazy(() =>
  import("../../Components/Home/Networking/Networking")
);

//Component

// Images
const bg_hero =
  "https://leapon-media.s3.amazonaws.com/media/webp_images/gc_1_png.webp";
// Images

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Leapon | Digital Business Cards & NFC Solutions",
  url: "https://leapon.tech",
  description:
    "Leapon offers innovative digital business cards, NFC cards, and seamless networking solutions to enhance your professional connections.",
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://leapon.tech",
      },
    ],
  },
  publisher: {
    "@type": "Organization",
    name: "Leapon Tech",
    url: "https://leapon.tech",
    logo: {
      "@type": "ImageObject",
      url: "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_1_png.webp",
      width: 250,
      height: 50,
    },
  },
  mainEntity: {
    "@type": "Product",
    name: "Digital Business Cards & NFC Business Cards Solutions",
    image:
      "https://leapon-media.s3.amazonaws.com/media/webp_images/Conversion_png_webp_LmkaBDj.webp",
    description:
      "Leapon's digital business cards and NFC solutions enable seamless contact sharing with customizable, eco-friendly features for professionals.",
    brand: {
      "@type": "Brand",
      name: "Leapon",
    },
    offers: {
      "@type": "Offer",
      priceCurrency: "USD",
      price: "6",
      availability: "https://schema.org/InStock",
      url: "https://leapon.tech",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      reviewCount: "20",
      bestRating: "5",
      worstRating: "1",
    },
  },
};

const ConnectData = [
  {
    id: 0,
    title: "Sales Teams",
    desc: "Transform your sales process with centralized contact management. With Leapon, your sales team spends less time on admin work and more time closing deals. Track every interaction, prioritize leads, and stay ahead of targets.",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/image_296_ccajws_png.webp",
    alt: " Leapon centralized contact management ",
    cta: "Book a Demo",
    link: "/get-demo#demo-booking",
  },
  {
    id: 1,
    title: "Marketing Teams",
    desc: "Leapon helps marketing teams build stronger relationships by simplifying contact organization and nurturing networks. Share brand-consistent digital business cards, keep track of event contacts, and integrate  with your CRM.",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Marketing_Teams_image_bwymzg_png.webp",
    alt: "Consistent branding with Leapon’s digital business card.",
    cta: "Book a Demo",
    link: "/get-demo#demo-booking",
  },
  {
    id: 2,
    title: "Small business teams",
    desc: "Empower your small business with tools that make collaboration and networking easier. From managing shared contacts to scheduling meetings, Leapon enables your team to deliver value to your clients and prospects.",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Small_Business_Teams_image_vfoadr_png.webp",
    alt: " Lead generation with Leapon profile",
    cta: "Book a Demo",
    link: "/get-demo#demo-booking",
  },
];

const UseCasesData = [
  {
    title: "Leapon for Entrepreneurs",
    category: "Streamline Business Relationships",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_1321316161_rtuceq_png.webp",
    alt: "Leapon for Entrepreneurs",
    link: "/blog/leapon-for-sales-professionals",
  },
  {
    title: "Leapon for Realtors ",
    category: "Boost Client Connections",
    alt: "Leapon for Realtors",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Figure_Picture_apple_intelligence__gbh77cvflkia_large_jpg_w0bv56_png.webp",
    link: "/blog/leapon-for-realtors-transforming-networking-and-lead-management",
  },

  {
    title: "Leapon for Financial Professionals",
    category: "Strengthen Trust Networks",
    alt: "Leapon for Financial Professionals",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_1321316162_u1iykj_png.webp",
    link: "/blog/transforming-financial-professional-networking-with-leapon",
  },
  {
    title: "Leapon for Freelancers",
    category: "Simplify Client Follow-Ups",
    img: "https://leapon-media.s3.amazonaws.com/media/webp_images/Figure_Picture_apple_intelligence__gbh77cvflkia_large_jpg_1_ws4h9f_png.webp",
    alt: "Leapon for Freelancers",
    link: "/blog/how-freelancers-can-transform-their-networking-game-the-power-of-digital-business-cards",
  },
];

const QuestionsData = [
  {
    id: 1,
    ques: "What does Leapon do?",
    ans: "Leapon is a powerful networking platform that seamlessly combines digital business cards with smart contact management. It empowers users to exchange, organize, and nurture professional relationships in a single, streamlined platform. By integrating with tools like Google and Outlook emails, calendars, and meeting apps, Leapon simplifies communication, optimizes workflows, and transforms casual interactions into meaningful business opportunities. Designed for professionals and teams, Leapon eliminates the need for multiple tools, saving time and boosting productivity. Whether you’re managing leads, scheduling meetings, or growing your network, Leapon provides a hassle-free, all-in-one solution to help you focus on what truly matters—building lasting connections.",
  },
  {
    id: 2,
    ques: "What is unique about Leapon’s digital business card?",
    ans: "Leapon’s digital business card offers a cutting-edge alternative to traditional paper cards, enabling seamless contact sharing through QR codes, digital links, and NFC technology. What truly sets Leapon apart is its customizability and dynamic profile capabilities, allowing users to tailor their cards with sections such as 'About,' social media links, services, featured images, reviews, and videos. Beyond sharing information, Leapon incorporates advanced smart contact management, letting users organize, track, and nurture their connections in one centralized place. Integration with tools like Google and Outlook streamlines communication and scheduling, ensuring no lead is lost. In essence, Leapon transcends the limitations of traditional business cards, offering professionals an efficient and comprehensive tool to enhance their networking efforts and grow their connections.",
  },
  {
    id: 3,
    ques: "How does a digital business card work?",
    ans: (
      <>
        A digital business card allows you to share your contact details
        instantly via QR codes, email, text, or NFC. When recipients interact
        with your card, they can:{" "}
        <ul>
          <li>
            Share Their Information: Recipients can provide their name, email,
            and phone number, which is automatically saved to your smart contact
            management system. They also receive an email with your details,
            ensuring a professional touch.
          </li>
          <li>
            Save Your Details: With a single tap, recipients can store your
            contact information, including your name, title, email, phone
            number, and social media links, directly to their device.
          </li>
        </ul>{" "}
        This quick and efficient process simplifies networking and ensures you
        never miss a connection.
      </>
    ),
  },
  {
    id: 4,
    ques: "What are the advantages of using a digital business card?",
    ans: "Digital business cards provide a cost-effective, eco-friendly alternative to paper cards, eliminating waste and offering instant updates. They allow for seamless sharing across devices via QR codes, NFC, or digital links, making contact exchange quick and effortless. Moreover, Leapon’s digital contact cards integrate with advanced contact management systems, enabling you to organize, track, and nurture your connections. Tools like Google and Outlook integration streamline scheduling and communication, ensuring you stay productive and focused. With these features, digital business cards offer an innovative solution for modern networking.",
  },
  {
    id: 5,
    ques: "Why should I choose smart contact management?",
    ans: "Smart contact management transforms the way you handle and nurture your connections. It offers the ability to add notes, set reminders, and plan follow-up actions, ensuring you never miss critical touchpoints. You can efficiently send emails, book meetings, and track your interaction history, helping you stay organized and focused. Integrated into Leapon’s ecosystem, smart contact management empowers professionals and SMEs to build meaningful relationships, close deals faster, and manage their networks seamlessly. This innovative approach is a game-changer for modern professionals looking to optimize their networking efforts.",
  },
  {
    id: 6,
    ques: "How secure is my information on a digital business card?",
    ans: "Leapon takes data security seriously, utilizing advanced two-factor encryption to protect your information. The platform complies with global security standards and certifications through AWS, including ISO 27017 for cloud security, ISO 27701 for privacy management, and ISO 27018 for cloud privacy. Your contact data is safeguarded at every step, ensuring privacy and secure sharing during professional interactions.",
  },
  {
    id: 7,
    ques: "Can I customize my digital business card?",
    ans: "Leapon’s digital business cards are designed with extensive customization options to reflect your unique brand identity. You can personalize your card with an About section to share your story and professional background, social links to connect seamlessly across platforms, and visuals like featured images and videos to enhance engagement. Additionally, you can showcase your offerings and customer feedback through dedicated reviews and services sections. This level of personalization ensures your digital card aligns with your personal or business brand, creating a compelling and professional impression.",
  },
  {
    id: 8,
    ques: "Is a digital business card compatible with all devices?",
    ans: "Leapon’s digital business cards are fully compatible with both Android and iOS devices, making them accessible across all major platforms.",
  },
  {
    id: 9,
    ques: "Why choose Leapon for a digital business card?",
    ans: "Leapon is more than just a digital business card—it’s a comprehensive networking solution that transforms how professionals connect and grow their relationships. It offers customizable designs to align with your personal or business identity and integrates smart contact management to help you organize, nurture, and track your network effortlessly. Sharing is made seamless with QR codes, digital links, and NFC technology, while integrations with tools like Google, Outlook, and Zapier streamline workflows and enhance lead management. With Leapon, professionals and teams can save time, minimize manual tasks, and focus on fostering productive connections. By redefining modern networking, Leapon provides a powerful and efficient way to grow your business relationships.",
  },
];

function HomePage() {
  useEffect(() => {
    $(window).scrollTop(0);
  }, []);

  return (
    <div className="homepage_con">
      <HeaderV2 />
      <MetaDecorator
        title={"Best Digital Business Card | Contact Management | Leapon"}
        description={
          "Elevate networking with Leapon's digital business card and smart contact management, integrated with your tools. Empower professionals and teams to thrive."
        }
        keyword="Best digital business card, Digital business card, Digital contact card, Contact management, Leapon's Smart Contact Management, all in one integration"
        jsonLd={jsonLd}
      />
      <div className="home_hero">
        <h1>
          A <span>Smarter Way</span> to <br />
          Network and Grow
        </h1>
        <p>
          Leapon combines the power of a digital business card with smart
          contact management, communication, and scheduling tools, giving you
          everything you need to thrive in one place.
        </p>
        <Link to="https://leapon.me/signup/" className="cta-btn">
          Get Started for Free
        </Link>
        <LazyLoadImage
          effect="blur"
          src={bg_hero}
          wrapperClassName="home_hero_img"
          alt="Image showing Leapon, which combines the power of a digital business card with smart contact management and tool integration."
        />
      </div>
      <UnifiedPlatform />
      <MasterContactsConnect
        data={ConnectData}
        title={
          <>
            Empowering High-Performing
            <br /> <span>Teams</span> Everywhere
          </>
        }
        desc={
          <>
            Equip your team with advanced tools for networking, contact
            <br /> management, and seamless communication—all integrated
            <br /> with your enterprise systems.
          </>
        }
      />
      <DesignedBuilt />
      <UseCases
        data={UseCasesData}
        title="Who are Leapon’s Users?"
        desc=" "
        className="home_hero"
      />
      <PersonalBrand />
      <div className="user_reviews_bg">
        <UserReview />
      </div>
      <Commitments />
      <Networking />
      <Questions Questions={QuestionsData} />
      <ResFooter isCard={true} btnDisable={true} />
    </div>
  );
}

export default HomePage;
